"use client";

import Link from "next/link";
import Image from "next/image";
import type { PublisherSearchResult } from "./types";
import { capture } from "@/lib/analytics/posthog";

interface PublisherResultItemProps {
  publisher: PublisherSearchResult;
  index: number;
  onSelect: () => void;
}

export function PublisherResultItem({
  publisher,
  index,
  onSelect,
}: PublisherResultItemProps) {
  const href = `/publisher/${publisher.clanid}`;

  return (
    <li
      style={{ animationDelay: `${index * 20}ms` }}
      className="animate-slide-in opacity-0"
    >
      <Link
        href={href}
        onClick={() => {
          capture("search result clicked", {
            kind: "publisher",
            clanid: publisher.clanid,
            position: index,
          });
          onSelect();
        }}
        className="block pr-2.5 pl-0 py-0 sm:pr-3 sm:pl-0 sm:py-0 text-xs sm:text-[13px] text-white hover:bg-[#1f2e3f] hover:text-[#66c0f4] transition-all duration-200 group relative overflow-hidden"
      >
        {publisher.backgroundHeader && (
          <div className="absolute inset-0 opacity-10">
            <Image
              src={publisher.backgroundHeader}
              alt=""
              fill
              className="object-cover"
              sizes="100vw"
            />
          </div>
        )}
        <div className="flex items-center justify-between gap-3 relative z-10">
          <div className="flex items-center gap-3 flex-1 min-w-0">
            <div className="w-7 h-7 sm:w-10 sm:h-10 border-0 bg-[#16202d] overflow-hidden relative flex-shrink-0">
              {publisher.avatar ? (
                <Image
                  src={publisher.avatar}
                  alt={publisher.name}
                  fill
                  sizes="40px"
                  className="object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center text-[10px] text-[#8f98a0]">
                  PUB
                </div>
              )}
            </div>
            <span className="group-hover:translate-x-1 inline-block transition-transform duration-200 font-medium truncate">
              {publisher.name}
            </span>
          </div>
          {publisher.gamesCount !== null && publisher.gamesCount !== undefined && (
            <span className="text-xs text-[#8f98a0] flex-shrink-0">
              {publisher.gamesCount} {publisher.gamesCount === 1 ? "game" : "games"}
            </span>
          )}
        </div>
      </Link>
    </li>
  );
}
